import * as Sentry from '@sentry/react';

/**
 * Capture an exception under a custom name, and optionally attach tags.
 *
 * Sentry titles the issue `customName: error.message`, so `customName` should
 * describe the failure category and `error` should carry the specific detail —
 * passing the caught error keeps the two from repeating each other.
 *
 * @param {Error}  error      – the Error to capture
 * @param {string} customName – the name/type you want Sentry to record
 * @param {Object} [tags]     – optional key/value map of tags, e.g. { is_webView: 'true' }
 */
export function captureCustomException(error, customName, tags) {
    Sentry.withScope((scope) => {
        if (tags && typeof tags === 'object') {
            for (const [k, v] of Object.entries(tags))
                scope.setTag(k, String(v));
        }

        const base = error instanceof Error ? error : new Error(String(error));
        const synthetic = new Error(base.message);
        synthetic.cause = base;
        synthetic.name = customName || base.name;

        if (base.stack) synthetic.stack = base.stack;

        Sentry.captureException(synthetic);
    });
}
